import React from 'react';

interface AircallIconProps {
  className?: string;
}

const AircallIcon: React.FC<AircallIconProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={className}
    >
      <path d="M30.07.86C27.82.34 24.123 0 19.943 0c-4.18 0-7.878.34-10.127.86C5.33 1.804 1.799 5.346.858 9.844.338 12.1 0 15.808 0 20s.339 7.9.858 10.156c.941 4.498 4.473 8.04 8.958 8.984 2.25.52 5.947.86 10.127.86 4.18 0 7.878-.34 10.127-.86 4.485-.944 8.017-4.486 8.958-8.984.52-2.256.858-5.964.858-10.156s-.339-7.9-.858-10.156c-.941-4.498-4.473-8.04-8.958-8.984z" fill="currentColor"></path>
      <path d="M24.735 30.705a3.023 3.023 0 00-2.16-1.79c-.584-.135-1.546-.223-2.632-.223-1.087 0-2.049.088-2.633.224-.97.204-1.77.876-2.151 1.77-.133.31-.45.499-.786.468a28.05 28.05 0 01-.215-.02c-1.564-.157-2.793-.375-3.507-.629a1.27 1.27 0 01-.816-1.354c.121-1.632 1.11-5.454 2.586-9.816 1.688-4.987 3.454-9.024 4.25-9.811a1.71 1.71 0 01.681-.436c.523-.177 1.487-.296 2.59-.296 1.104 0 2.068.119 2.59.296l.009.003a1.711 1.711 0 01.674.433c.796.787 2.561 4.824 4.249 9.81 1.477 4.363 2.465 8.185 2.587 9.817 0 .013 0 .027.002.041l.002.015a6.196 6.196 0 01.004.108 1.27 1.27 0 01-.824 1.19c-.714.254-1.942.472-3.504.628l-.246.023a.74.74 0 01-.75-.45z" className="fill-white dark:fill-black"></path>
    </svg>
  );
};

export default AircallIcon;
